import { parseRecordKey, recordKey, recordPrefix } from './local-key-encoding.js';
/**
 * Synchronous helpers for reading the local provider's envelopes directly.
 * Used by sync-API adapters that can't await the async StorageProvider methods.
 */
export function readLocalRecord(ns, key) {
    if (typeof localStorage === 'undefined')
        return null;
    const raw = localStorage.getItem(recordKey(ns, key));
    if (!raw)
        return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed.sidecars)
            delete parsed.sidecars;
        return parsed;
    }
    catch {
        return null;
    }
}
export function listLocalRefs(ns) {
    if (typeof localStorage === 'undefined')
        return [];
    const prefix = recordPrefix(ns);
    const out = [];
    for (let i = 0; i < localStorage.length; i++) {
        const storageKey = localStorage.key(i);
        if (!storageKey || !storageKey.startsWith(prefix))
            continue;
        const parsed = parseRecordKey(storageKey);
        if (!parsed || parsed.namespace !== ns)
            continue;
        const raw = localStorage.getItem(storageKey);
        if (!raw)
            continue;
        try {
            const env = JSON.parse(raw);
            out.push({
                namespace: env.namespace,
                key: env.key,
                updatedAt: env.updatedAt,
                deletedAt: env.deletedAt,
            });
        }
        catch {
            // skip corrupt
        }
    }
    return out;
}
export function listLocalRecords(ns) {
    if (typeof localStorage === 'undefined')
        return [];
    const prefix = recordPrefix(ns);
    const out = [];
    for (let i = 0; i < localStorage.length; i++) {
        const storageKey = localStorage.key(i);
        if (!storageKey || !storageKey.startsWith(prefix))
            continue;
        const parsed = parseRecordKey(storageKey);
        if (!parsed || parsed.namespace !== ns)
            continue;
        const raw = localStorage.getItem(storageKey);
        if (!raw)
            continue;
        try {
            const rec = JSON.parse(raw);
            if (rec.sidecars)
                delete rec.sidecars;
            out.push(rec);
        }
        catch {
            // skip corrupt
        }
    }
    return out;
}
//# sourceMappingURL=local-sync.js.map